import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Styles from './Styles/EmptyStore.module.css'
import { useNavigate } from 'react-router-dom';

export default function EmptyStore() {
    const navigate = useNavigate()

    return (
        <div className={Styles.container}>

            <Stack className={Styles.content} justifyContent='space-evenly' alignItems='center' spacing={2} sx={{ textAlign: 'center' }}>
                <Typography variant='h4'>
                    Este negocio actualmente no tiene productos
                </Typography>
                <Typography variant='h6'>
                    Eres el adminsitrador de este negocio?
                </Typography>
                <Button variant='outlined' onClick={() => navigate('/')}>
                    Ir a Tookeat
                </Button>
            </Stack>

        </div>
    )
}